import {
    useEffect,
    useState,
} from 'react';

import {
    Autocomplete,
    AutocompleteProps,
    Group,
    Text
} from '@mantine/core';

import {useAccounts} from '../hooks/useAccounts';
import {Account} from '../types';
import {FieldProps} from 'formik';

export const AccountsAutocomplete = ({
                                         field,
                                         form: {setFieldValue},
                                         ...rest
                                     }: FieldProps) => {

    const [value, setValue] = useState<string | undefined>();

    const {
        items: accounts,
    } = useAccounts();

    useEffect(() => {
        const record = accounts.find((record: Account) => record.email === field.value);
        if (record) {
            setValue(record.email);
        }
    }, [accounts.length]);


    const renderAutocompleteOption: AutocompleteProps['renderOption'] = ({option}) => {
        const record = accounts.find((record: Account) => record.email === option.value);
        return (
            <Group gap="sm">
                <div>
                    <Text size="sm">{record?.email} [ {record?.accountType} ]</Text>
                </div>
            </Group>
        )
    };

    const data = accounts.map((record: Account) => {
        return record.email;
    });


    const handleChange = (value: string) => {
        setValue(value);

        const record = accounts.find((record: Account) => record.email === value);
        setFieldValue(field.name, record ? record.id : '');
    };

    const handleBlur = () => {
        const record = accounts.find((record: Account) => record.email === value);
        setFieldValue(field.name, record ? record.id : '', true);
    };

    return (
        <Autocomplete
            name={field.name}
            value={value}
            renderOption={renderAutocompleteOption}
            onChange={handleChange}
            onBlur={handleBlur}
            data={data}
            // disabled={disabled}
            placeholder='Select Component'
            {...rest}
        />
    );
};
